export const idFromObject = <T extends Nullable<string>>(relayId: T): T => {
  return relayId?.split(':').slice(-1)[0] as T;
};
